import { ISquadPlayer, SquadAbsenceReason } from '../interfaces/squad.interface';

/** Local calendar day as `YYYY-MM-DD`, the format absences are stored in. */
export const toDay = (date: Date): string => {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
};

/** `YYYY-MM-DD` as local midnight — `new Date('YYYY-MM-DD')` would be UTC and can show the previous day. */
export const fromDay = (day: string): Date => {
    const [year, month, date] = day.split('-').map(Number);
    return new Date(year, month - 1, date);
};

/** The player's absence reason if it covers `day` (an end date is inclusive), otherwise null. */
export const absenceOn = (player: ISquadPlayer, day: string): SquadAbsenceReason | null => {
    if (!player.absenceReason) {
        return null;
    }
    return !player.absentUntil || player.absentUntil >= day ? player.absenceReason : null;
};

/** Short, localized day for absence labels: "12. Okt." / "Oct 12". */
export const formatAbsenceDay = (day: string, language: string): string =>
    new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short' }).format(fromDay(day));
